const downloadFile = (data, headers) => {
  const blob = new Blob([data])
  // 從 headers 獲取文件名
  const contentDisposition = headers['content-disposition']
  const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  const result = patt.exec(contentDisposition)
  const fileName = result[1]
  // debugger

  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 釋放 URL 對象
    document.body.removeChild(elink)
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

const downloadPdf = (data, headers) => {
  const blob = new Blob([data], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  openFile(url)
}

const openFile = (path) => {
  const result = window.open(path, '_blank')
  // about:blank
  setTimeout(() => {
    const href = result.location.href
    if(!href) {
      // 頁面沒打開，可能被攔截了
      window.message({
        type: 'warning',
        message: 'error: 請檢查您的瀏覽器是否安裝有廣告攔截插件'
      })
    }
  }, 1000)
}

export {
  downloadFile,
  downloadPdf,
  openFile
}